import { UserIcon } from '@synoptic/ui-kit/icons/react/user.tsx';
import { clsx } from 'clsx';
import { FC } from 'react';
import { streamFollowersBlock } from '@/components/streams/stream-followers/stream-followers.css.ts';

export const StreamFollowers: FC<{
  followersCount: number;
  iconSize?: number;
  className?: string;
}> = ({ followersCount, iconSize = 16, className }) => (
  <div
    className={clsx(streamFollowersBlock, className)}
    data-testid={'streamFollowersBlock'}
  >
    <UserIcon width={iconSize} height={iconSize} />
    <span>{followersCount}</span>
  </div>
);
